<template>
    <div class="wineguide-container">
        <div class="itips-head">
            <div class="container">
                <div class="inner-page-title">{{ $t("home-top4") }}</div>
                <div class="inenr-page-breadcrumb">
                    <div class="inner-page-bread-line"></div>
                </div>
            </div>
        </div>
        <div class="container">
            <div class="wine-guide-body">
                <div class="wine-guide-left hide-mobile">
                    <div class="wine-guide-left-title">
                        <nuxt-link class="wine-guide-back"
                                   :to="localePath('/wine-guide/south-africa/stellenbosch')"></nuxt-link>
                        Producers
                    </div>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/south-africa/stellenbosch/alto-wine-estate')">Alto Wine
                        Estate
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/south-africa/stellenbosch/kanonkop-paul-sauer')">Kanonkop
                        Paul Sauer
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/south-africa/stellenbosch/meerlust-estate')">Meerlust Estate
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/south-africa/stellenbosch/savanha-wines')">Savanha Wines
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country active"
                               :to="localePath('/wine-guide/south-africa/stellenbosch/the-sadie-family-wines')">The
                        Sadie Family Wines
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/south-africa/stellenbosch/thelema-mountain-vineyards')">
                        Thelema Mountain Vineyards
                    </nuxt-link>
                </div>
                <div class="show-mobile">
                    <div class="wine-guide-left-title">
                        <nuxt-link class="wine-guide-back"
                                   :to="localePath('/wine-guide/south-africa/stellenbosch')"></nuxt-link>
                        Producers
                    </div>
                    <v-select
                        :items="items"
                        v-model="select"
                        label="Please choose"
                        single-line
                        item-text="report"
                        item-value="src"
                        return-object
                        class="show-mobile show-mobile-select"
                        v-on:change="changeRoute"
                    ></v-select>
                </div>
                <div v-if="$i18n.locale === 'it'" class="wine-guide-right">
                    <div class="howto-title">I vini della famiglia Sadie</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        Uno dei rari vini pregiati sudafricani a perforare il mercato degli investitori carico di Europa, la famiglia Sadie e il loro vino omonimo, hanno molto di cui sorridere.
                    </div>

                    <div class="howto-title2">L'enfant terrible di Stellenbosch</div>
                    <div class="howto-text">
                        Considerato uno dei leader del crescente movimento sudafricano di interesse per i "vini della nuova ondata".
                        Il vino di Eben Sadie è aumentato notevolmente negli ultimi anni. Considerato qualcosa di un
                        anticonformista nel settore, Sadie sembra non essere influenzata dal suo soprannome; "Lavoro e basta", dice,
                        tipicamente schietto. “Non mi interessano gli altri”. Questo atteggiamento gli è valso un
                        reputazione di essere volatile, anche difficile. Fa due annate all'anno, una a casa nella sua
                        amato Swartland, e uno nella sua casa adottiva a Priorat, Spagna, Tuttavia, come spesso accade
                        caso con le superstar, possiamo concedergli un piccolo margine di manovra per le sue idiosincrasie. “Nel giro di un'annata
                        era ovvio che fosse destinato a grandi cose", afferma Charles Back, di The Spice Route Winery
                        dove Sadie ha iniziato la sua carriera viticola. "È una risorsa nazionale". Non possedere alcuna terra lui stesso
                        (in Sud Africa, i suoi vini spagnoli sono prodotti da viti di sua proprietà), Sadie osserva da vicino
                        le parcelle di terroir, un po' come si farebbe in Borgogna. Con cinque diversi terreni
                        tipi a breve distanza dalla cantina di Sadie, non bisogna mai dimenticare di aspettarsi l'inaspettato
                        con uno dei suoi vini.
                    </div>

                    <div class="howto-title2">Le vecchie vigne sono le migliori</div>
                    <div class="howto-text">
                        Meglio conosciuto per il suo Columella (il 2006, al dettaglio a circa 80 € sul mercato secondario è
                        indiscutibilmente uno dei suoi migliori), Sadie produce anche due ottimi bianchi. Il suo Palladio ha un
                        punteggio medio aggregato di 93/100 per tutte le annate, e il suo Mrs Kirsten's Old Vines Chenin
                        Blanc, prodotto da un unico cespuglio di viti di 90 anni esaurito in poche ore (nonostante il suo
                        prezzo discutibile). Della sua annata inaugurale 2006 sono state prodotte solo 680 bottiglie, e
                        se sei abbastanza fortunato da trovare una bottiglia sul mercato secondario, faresti bene a scattare
                        su, qualunque sia il prezzo.
                    </div>

                    <div class="howto-title2">Ciao Swartland! Non ti abbiamo visto lì</div>
                    <div class="howto-text">
                        Sì, Eben Sadie è un anarchico viticolo e sì, i suoi prezzi sono al di sopra dei suoi
                        Concorrenti di Stellenbosch. Tuttavia, una cosa è certa: Eben Sadie ha messo Swartland sul
                        mappe e ha dimostrato al resto del mondo che il Sudafrica è più che capace di produrre
                        vini di classe mondiale.
                    </div>
                </div>
                <div v-else-if="$i18n.locale === 'de'" class="wine-guide-right">
                    <div class="howto-title">Die Weine der Familie Sadie</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        Die Familie Sadie und ihr gleichnamiger Wein sind einer der seltenen südafrikanischen Edelweine, die den europäischen Anlegermarkt erobern und haben viel Grund zum Schmunzeln.
                    </div>

                    <div class="howto-title2">Das Enfant terrible von Stellenbosch</div>
                    <div class="howto-text">
                        Gilt als einer der Anführer der wachsenden südafrikanischen Bewegung für „New-Wave-Weine“.
                        Der Weinanbau von Eben Sadie hat in den letzten Jahren dramatisch zugenommen. Wird als etwas angesehen
                        Sadie ist ein Außenseiter in der Branche und scheint von seinem Spitznamen nicht berührt zu sein. „Ich arbeite einfach“, sagt er,
                        typischerweise offenherzig. „Die anderen interessieren mich nicht.“ Diese Einstellung hat ihm eine Auszeichnung eingebracht
                        Ruf als volatil, sogar schwierig. Er macht zwei Jahrgänge pro Jahr, einen davon zu Hause in seinem
                        geliebtes Swartland, und einer in seiner Wahlheimat in Priorat, Spanien, Allerdings wie so oft
                        Wie es bei Superstars der Fall ist, können wir ihm ein wenig Spielraum für seine Eigenheiten lassen. „Innerhalb eines Jahrgangs
                        Es war offensichtlich, dass er zu Großem berufen war“, sagt Charles Back von The Spice Route Winery
                        wo Sadie seine Weinbaukarriere begann. „Er ist eine nationale Bereicherung.“ Besitzt selbst kein Land
                        (In Südafrika werden seine spanischen Weine aus Reben hergestellt, die er besitzt), schaut sich Sadie genau an
                        die Parzellen des Terroirs, eher so, wie man es im Burgund tun würde. Mit fünf verschiedenen Böden
                        Sorten in unmittelbarer Nähe von Sadies Weingut, man darf nie vergessen, mit dem Unerwarteten zu rechnen
                        mit einem seiner Weine.
                    </div>

                    <div class="howto-title2">Die alten Reben sind die besten</div>
                    <div class="howto-text">
                        Am bekanntesten ist sein Columella (2006), der auf dem Zweitmarkt für rund 80 Euro erhältlich ist
                        (zweifellos einer seiner besten), Sadie produziert auch zwei ausgezeichnete Weißweine. Sein Palladius hat eine
                        durchschnittliche Gesamtpunktzahl von 93/100 für alle Jahrgänge und sein Mrs Kirsten’s Old Vines Chenin
                        Blanc, hergestellt aus einem einzigen Busch 90 Jahre alter Reben, war innerhalb weniger Stunden ausverkauft (trotz seiner
                        fragwürdiger Preis). Vom ersten Jahrgang 2006 wurden nur 680 Flaschen produziert
                        Sollten Sie das Glück haben, auf dem Sekundärmarkt eine Flasche zu finden, wäre es ratsam, sie zu ergattern
                        es hoch, egal zu welchem Preis.
                    </div>

                    <div class="howto-title2">Hallo Swartland! Wir haben dich dort nicht gesehen</div>
                    <div class="howto-text">
                        Ja, Eben Sadie ist ein Weinanarchist und ja, seine Preise liegen weit über seinen
                        Konkurrenten aus Stellenbosch. Eines ist jedoch sicher: Eben Sadie hat Swartland auf den Plan gerufen
                        Karten erstellt und dem Rest der Welt bewiesen, dass Südafrika mehr als fähig ist, etwas zu produzieren
                        Weltklasse-Weine.
                    </div>
                </div>
                <div v-else-if="$i18n.locale === 'fr'" class="wine-guide-right">
                    <div class="howto-title">Les vins de la famille Sadie</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        L'un des rares vins fins sud-africains à percer le marché des investisseurs européens, la famille Sadie et son vin éponyme ont de quoi sourire.
                    </div>

                    <div class="howto-title2">L'enfant terrible de Stellenbosch</div>
                    <div class="howto-text">
                        Considéré comme l'un des leaders du mouvement croissant des «vins de la nouvelle vague» en Afrique du Sud, l'intérêt pour
                        Le vin d'Eben Sadie a considérablement augmenté au cours des dernières années. Considéré comme quelque chose d'un
                        franc-tireur dans l'industrie, Sadie ne semble pas affecté par son surnom; "Je travaille juste", dit-il,
                        typiquement franc. "Je ne m'intéresse pas aux autres". Cette attitude lui a valu une
                        réputation d'être volatile, voire difficile. Il fait deux cuvées par an, une chez lui dans son
                        bien-aimé Swartland, et un dans sa maison d'adoption du Priorat, en Espagne. Cependant, comme c'est si souvent le cas
                        cas avec des superstars, nous pouvons lui laisser une petite marge de manœuvre pour ses idiosyncrasies. « Dans un millésime
                        il était évident qu'il était destiné à de grandes choses », déclare Charles Back, de The Spice Route Winery
                        où Sadie a commencé sa carrière viticole. "C'est un atout national". Ne possédant pas de terrain lui-même
                        (en Afrique du Sud, ses vins espagnols sont élaborés à partir de vignes qu'il possède), Sadie regarde de près
                        les parcelles de terroir, un peu comme on le ferait en Bourgogne. Avec cinq sols différents
                        types à une courte distance de la cave de Sadie, il ne faut jamais oublier de s'attendre à l'inattendu
                        avec un de ses vins.
                    </div>

                    <div class="howto-title2">Les vieilles vignes sont les meilleures</div>
                    <div class="howto-text">
                        Surtout connu pour son Columelle (le 2006, vendu aux alentours de 80 € sur le marché secondaire est
                        incontestablement l'un de ses meilleurs), Sadie produit également deux excellents blancs. Son Palladius a un
                        note globale moyenne de 93/100 pour tous les millésimes, et son Mrs Kirsten’s Old Vines Chenin
                        Blanc, issu d'un seul buisson de vignes de 90 ans vendu en quelques heures (malgré sa
                        prix discutable). Seulement 680 bouteilles ont été produites de son millésime inaugural 2006, et
                        si vous avez la chance de trouver une bouteille sur le marché secondaire, vous feriez bien de craquer
                        ça monte, quel que soit le prix.
                    </div>

                    <div class="howto-title2">Bonjour Swartland! Nous ne vous avons pas vu là-bas</div>
                    <div class="howto-text">
                        Oui, Eben Sadie est un anarchiste viticole et oui, ses prix sont au-dessus de ses
                        Concurrents de Stellenbosch. Cependant, une chose est certaine : Eben Sadie a mis Swartland sur le devant de la scène.
                        cartes et prouvé au reste du monde que l'Afrique du Sud est plus que capable de produire
                        vins de classe mondiale.
                    </div>
                </div>
                <div v-else class="wine-guide-right">
                    <div class="howto-title">The Sadie Family Wines</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        One of the rare South African fine wines to pierce the European-laden investors market, the Sadie Family, and their eponymous wine, have a lot to smile about.
                    </div>

                    <div class="howto-title2">The enfant terrible of Stellenbosch</div>
                    <div class="howto-text">
                        Considered one of the leaders of South Africa’s growing movement of “new wave wines” interest in
                        Eben Sadie’s wine has increased dramatically over the past few years. Considered something of an
                        maverick in the industry, Sadie appears unaffected by his moniker; “I just work”, he says,
                        typically outspoken. “I’m not interested in the others”. This attitude has earned him a
                        reputation for being volatile, even difficult. He makes two vintages a year, one at home in his
                        beloved Swartland, and one at his adopted home in Priorat, Spain, However, as is so often the
                        case with superstars, we can allow him a little leeway for his idiosyncrasies. “Within a vintage
                        it was obvious he was destined for great things,” says Charles Back, of The Spice Route Winery
                        where Sadie began his viticultural career. “He’s a national asset”. Not owning any land himself
                        (in South Africa, his Spanish wines are made from vines that he owns), Sadie looks closely at
                        the parcels of terroir, rather in the same way one would in Burgundy. With five different soil
                        types within a short distance of Sadie’s winery, one must never forget to expect the unexpected
                        with one of his wines.
                    </div>

                    <div class="howto-title2">The old vines are the best</div>
                    <div class="howto-text">
                        Best known for his Columella (the 2006, retailing at around €80 on the secondary market is
                        unquestionably one of his best), Sadie also produces two excellent whites. His Palladius has an
                        average aggregate score of 93/100 for all vintages, and his Mrs Kirsten’s Old Vines Chenin
                        Blanc, produced from a single bush of 90-year old vines sold out in a few hours (despite its
                        questionable price tag). Just 680 bottles were produced of its inaugural 2006 vintage, and
                        should you be lucky enough to find a bottle on the secondary market, you would be wise to snap
                        it up, whatever the price.
                    </div>

                    <div class="howto-title2">Hello Swartland! We didn&#39;t see you there</div>
                    <div class="howto-text">
                        Yes, Eben Sadie is a viticultural anarchist and yes, his prices are over and above his
                        Stellenbosch competitors. However, One thing is certain: Eben Sadie has put Swartland on the
                        maps and proved to the rest of the world that South Africa is more than capable of producing
                        world-class wines.
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "TheSadieFamilyWines",
    data() {
        return {
            select: {
                report: 'The Sadie Family Wines',
                src: '/wine-guide/south-africa/stellenbosch/the-sadie-family-wines'
            },
            items: [
                {report: 'Alto Wine Estate', src: '/wine-guide/south-africa/stellenbosch/alto-wine-estate'},
                {report: 'Kanonkop Paul Sauer', src: '/wine-guide/south-africa/stellenbosch/kanonkop-paul-sauer'},
                {report: 'Meerlust Estate', src: '/wine-guide/south-africa/stellenbosch/meerlust-estate'},
                {report: 'Savanha Wines', src: '/wine-guide/south-africa/stellenbosch/savanha-wines'},
                {report: 'The Sadie Family Wines', src: '/wine-guide/south-africa/stellenbosch/the-sadie-family-wines'},
                {
                    report: 'Thelema Mountain Vineyards',
                    src: '/wine-guide/south-africa/stellenbosch/thelema-mountain-vineyards'
                }
            ]
        }
    },
    methods: {
        changeRoute(a) {
                this.$router.push({path: this.localePath(a.src) });
            }
    },
    head: {
        title: 'The Sadie Family Wines | Vindome Wine Guide',
        meta: [
            {
                hid: 'description',
                name: 'description',
                content: 'Discover the exceptional quality and unique flavor of The Sadie Family Wines, a premium South African wine producer. Experience the art of winemaking at its finest.'
            }
        ],
        bodyAttrs: {
            class: 'wine-guide inner-page'
        }
    }
}
</script>

<style scoped>
    .container {
        max-width: 1170px;
        padding: 0;
        font-family: 'Poppins', sans-serif;
    }
    .wine-guide-body {
        padding-top: 35px;
    }
    .wine-guide-left {
        width: 300px;
        display: inline-block;
    }
    .wine-guide-right {
        display: inline-block;
        width: calc(100% - 305px);
        vertical-align: top;
    }
    .wine-guide-left-title {
        font-weight: 600;
        color: #024E7B;
        font-size: 18px;
        height: 57px;
        line-height: 57px;
    }
    .wine-guide-country {
        display: block;
        height: 57px;
        line-height: 57px;
        text-decoration: none;
        color: #000;
        font-size: 16px;
        padding-left: 30px;
        width: 260px;
        border-left: 3px solid transparent;
    }
    .wine-guide-country:hover,
    .wine-guide-country.active {
        border-color: #024E7B;
        background: #E5EDF2;
    }
</style>
